<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()"
        v-if="convenio.idSituacaoConvenio != 9">
            Adicionar
        </b-button>
        <cronograma-desembolso-form
            operacaoProp="I"
            :convenio="convenio"
            :cronogramaDesembolso="cronogramaDesembolso"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></cronograma-desembolso-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import CronogramaDesembolsoForm from './CronogramaDesembolsoForm'

export default {
    components: {
        CronogramaDesembolsoForm
    },

    props: {
        convenio: Object,
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            cronogramaDesembolso: {
                codSituacao: null,
                dtLiberacao: null,
                dtMesAno: null,
                idConvenio: 0,
                idCronogramaDesembolso: 0,
                nuParcela: 1,
                nuValorDesembolso: 0,
                percExecucao: null,
                vcDescricao: null,
                vlLiberado: null
            },
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(cronogramaDesembolso){
            this.$store.dispatch('addRequest')
            let cronogramaDesembolsoDto = {
                idConvenio : this.$route.params.convenioId,
                codSituacao: cronogramaDesembolso.codSituacao,
                dtLiberacao:cronogramaDesembolso.dtLiberacao,
                dtMesAno:cronogramaDesembolso.dtMesAno,
                idCronogramaDesembolso:cronogramaDesembolso.idCronogramaDesembolso,
                nuParcela:cronogramaDesembolso.nuParcela,
                nuValorDesembolso:cronogramaDesembolso.nuValorDesembolso,
                percExecucao:cronogramaDesembolso.percExecucao,
                vcDescricao:cronogramaDesembolso.vcDescricao,
                vlLiberado:cronogramaDesembolso.vlLiberado,
            }
            ConveniosServicos.inserirCronogramaDesembolso(cronogramaDesembolsoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Cronograma inserido com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
